module.exports = __webpack_public_path__ + "static/media/texture-wood-black-v.f80dedcf.jpg";